import { render } from "./dropdown-sidebar.vue?vue&type=template&id=bd97f932&scoped=true"
import script from "./dropdown-sidebar.vue?vue&type=script&lang=js"
export * from "./dropdown-sidebar.vue?vue&type=script&lang=js"

import "./dropdown-sidebar.vue?vue&type=style&index=0&id=bd97f932&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd97f932"]])

export default __exports__